import React, { Component } from 'react'
import GenericHeader from '../GenericHeader'
import { Form, Input, InputNumber, Button, Select } from 'antd'
import { getAccountName, transferFunds, getAllActiveAccountProviders } from '../../actions'
import { connect } from 'react-redux'
const FormItem = Form.Item
const Option = Select.Option

const INIT_STATE = {
  showAccountName: false,
  accountName: '',
  loading: false,
}
const mapStateToProps = state => {
  return {
    accountBalance: state.bankSimulator.accountBalance,
    accountProviders: state.bankSimulator.accountProviders,
  }
}
@connect(mapStateToProps, { getAccountName, transferFunds, getAllActiveAccountProviders })
@Form.create()
class TransferScreen extends Component {
  state = INIT_STATE

  componentDidMount() {
    this.props.getAllActiveAccountProviders(accountProviders => {
      console.log('Retrieved results', accountProviders)
    })
  }
  onSubmit = isSubmitForm => event => {
    event.preventDefault()
    const { form } = this.props

    if (!isSubmitForm) {
      var accountNumber = form.getFieldValue('accountNumber')
      var accountValidated = true

      if (!accountNumber && this.state.accountName === '') {
        accountValidated = false
      }
      form.validateFields((error, values) => {
        if (!error && accountValidated) {
          this.setState({ loading: true })
          this.props.transferFunds(values, () => {
            this.setState({ loading: false })
          })
        }
      })
    }
  }

  validateAmount = (rule, value, callback) => {
    if (this.props.accountBalance < value) {
      callback('Insufficient balance to cover transaction')
    } else {
      callback()
    }
  }

  onAccountNumberChange = (rule, value, callback) => {
    this.setState(INIT_STATE)
    this.props.getAccountName(value, (validAccount, accountName) => {
      if (validAccount) {
        callback()
        this.setState({ showAccountName: true, accountName })
        //update the accountName
      } else {
        callback('Invalid Account')
        this.setState(INIT_STATE)
      }
    })
  }

  hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field])
  }

  renderAccountName = form => {
    if (this.state.showAccountName) {
      return (
        <div className="col-lg-12" style={{ marginLeft: '20px' }}>
          <FormItem label="Account Name">
            {form.getFieldDecorator('accountName', {
              initialValue: this.state.accountName,
            })(<Input disabled size="large" placeholder="Account Number" />)}
          </FormItem>
        </div>
      )
    } else {
      return null
    }
  }
  renderForm = () => {
    const { form, accountProviders } = this.props
    return (
      <div className="row" style={{ marginTop: '30px' }}>
        <Form layout="vertical" onSubmit={this.onSubmit(this.state.loading)}>
          <div className="col-lg-12" style={{ marginLeft: '20px' }}>
            <FormItem label="Account Number" hasFeedback>
              {form.getFieldDecorator('accountNumber', {
                validateFirst: true,
                rules: [
                  { required: true, message: 'required' },
                  { min: 10, message: 'Must be 10 digits' },
                  { max: 10, message: 'Must be 10 digits' },
                  { validator: this.onAccountNumberChange },
                ],
              })(<Input size="large" placeholder="Account Number" />)}
            </FormItem>
          </div>

          <div className="col-lg-12" style={{ marginLeft: '20px' }}>
            <FormItem label="Bank">
              {form.getFieldDecorator('bank', {
                validateFirst: true,
                rules: [{ required: true, message: 'required' }],
              })(
                <Select size="large" placeholder="Select Bank">
                  {accountProviders.map(({ code, name }) => {
                    return (
                      <Option key={code} value={code}>
                        {name}
                      </Option>
                    )
                  })}
                </Select>,
              )}
            </FormItem>
          </div>

          {this.renderAccountName(form)}

          <div className="col-md-12" style={{ marginLeft: '20px' }}>
            <FormItem label="Amount">
              {form.getFieldDecorator('amount', {
                rules: [
                  { required: true, message: 'required' },
                  { validator: this.validateAmount },
                ],
              })(
                <InputNumber
                  style={{ width: '100%' }}
                  size="large"
                  placeholder="Transaction Amount"
                />,
              )}
            </FormItem>
          </div>

          <div className="form-actions text-center">
            <Button
              type="primary"
              className="width-150 mr-4"
              htmlType="submit"
              disabled={this.hasErrors(form.getFieldsError())}
              loading={this.state.loading}
            >
              Make Payment
            </Button>
          </div>
        </Form>
      </div>
    )
  }
  render() {
    return (
      <div>
        <GenericHeader height="60px" />
        {this.renderForm()}
      </div>
    )
  }
}

export default TransferScreen



// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/InternetBankingSimulatorApp/screens/TransferScreen/index.js